import { render, staticRenderFns } from "./Dados.vue?vue&type=template&id=12828007&scoped=true&"
import script from "./Dados.vue?vue&type=script&lang=js&"
export * from "./Dados.vue?vue&type=script&lang=js&"
import style0 from "./Dados.vue?vue&type=style&index=0&id=12828007&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12828007",
  null
  
)

export default component.exports